import React from "react";
//outsource
import { Row, Col, DatePicker } from "antd";
import moment from "moment";
//components

const DialogTime = ({ date, time, setTime, lastTime, disabled }) => {
  // -------------------------- VAR --------------------------

  const lastTimeTrack = renderTimeTrack(date, lastTime);
  // console.log({ lastTimeTrack });
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  const handleChange = (time) => {
    console.log({ time });
    setTime(time);
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      format="hh:mm A"
      placeholder="Choose Time"
      picker="time"
      onChange={handleChange}
      disabled={disabled}
      value={time}
      showNow={false}
      allowClear={false}
      // disabledDate={(current) => {
      //   const valids = current && current <= lastTimeTrack;

      //   return valids;
      // }}
    />
  );
};

export default DialogTime;

const renderTimeTrack = (date, lastTime) => {
  const lastTimeTrack = lastTime?.seconds && moment(lastTime?.toDate());
  const track = lastTimeTrack?.format("hh:mm A");

  const dateString = date?.format("DD/MM/YYYY");
  return moment(`${dateString} ${track}`, "DD/MM/YYYY hh:mm A");
};
